/* eslint-disable */
import React from 'react';
import Grow from '@mui/material/Grow';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    main: {
      display: 'flex',
      flex: '1 0 auto',
      float: 'right'
    },
    searchIcon: {
      color: theme.palette.text.secondary,
      marginTop: '10px',
      marginRight: '8px'
    },
    searchText: {
      flex: '0.8 0'
    },
    clearIcon: {
      '&:hover': {
        color: theme.palette.error.main
      }
    }
  }),
  { name: 'MUIDataTableSearch' }
);

const TableSearch = ({ options, searchText, onSearch, onHide }) => {
  const classes = useStyles();

  const handleTextChange = (event) => {
    onSearch(event.target.value);
  };

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      onHide();
    }
  };

  const clearIconVisibility = options.searchAlwaysOpen ? 'hidden' : 'visible';

  return (
    <Grow appear in={true} timeout={300}>
      <div className={classes.main}>
        <TextField
          className={classes.searchText}
          autoFocus={true}
          InputProps={{
            'data-test-id': options.textLabels.toolbar.search,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="secondary" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton className={classes.clearIcon} style={{ visibility: clearIconVisibility }} onClick={() => onSearch('')}>
                  <ClearIcon color="secondary" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          inputProps={{
            'aria-label': options.textLabels.toolbar.search
          }}
          value={searchText || ''}
          onKeyDown={onKeyDown}
          onChange={handleTextChange}
          fullWidth={true}
          placeholder={options.searchPlaceholder}
          {...(options.searchProps ? options.searchProps : {})}
        />
      </div>
    </Grow>
  );
};

export default TableSearch;
